import React from 'react';
import _get from 'lodash/get';
import VisualNav from 'yoda-core-components/lib/components/VisualNav/VisualNav';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import RevieveModal from '../../../components/Revieve/RevieveModal';
import RichText from '../../../components/RichText/RichText';

export const massageProps = (props, preferences) => {
    const massagedData = [];
    /* istanbul ignore next */
    if (props && props.items) {
        const itemsArr = props.items;
        itemsArr.forEach((value) => {
            let itemObj = {};
            const {
                linkText: title = '',
                image: imageUrl = '',
                link: linkUrl = '',
                analyticsTag = '',
                openInNewTab = false,
            } = value;
            let { url: image = '' } = imageUrl;
            const { altText = '' } = imageUrl;
            const { url: links = '' } = linkUrl;
            const ext = checkUrlExtension(value.image.url);
            image = replaceSubdomain(image, preferences);
            itemObj = { title, image, links, analyticsTag, openInNewTab, ext, altText };
            massagedData.push(itemObj);
        });
    }
    return massagedData;
};

/* istanbul ignore next */
export const renderTheme = (pageType, exclusions = [], enableRndVizNav) => {
    let themeName = 'visualNavList';
    if (enableRndVizNav && exclusions.indexOf(pageType) === -1) {
        themeName = 'roundedTheme';
    }
    return themeName;
};
/* istanbul ignore next */
export const alignmentTheme = (props = {}) =>
    props.theme &&
    (props.theme.large === 'headline-left' || props.theme.compact === 'headline-above');

/* istanbul ignore next */
export const applyVizNavTheme = (props = {}, deviceType = {}) =>
    props.theme && (deviceType.isMobile ? props.theme.compact : props.theme.large);

export const enableSlider = (props = {}) => {
    return props.style === 'classic';
};

const componentRendered = (props) => {
    const {
        title,
        headline,
        subHeadline,
        pageType,
        deviceType,
        preferences,
        automationId,
        featureFlags,
    } = props;

    return (
        <VisualNav
            pageName={pageType}
            departmentTitle={title}
            headline={<RichText text={headline} />}
            subHeadline={<RichText text={subHeadline} />}
            datasource={massageProps(props, preferences)}
            enableCarouselSlider={enableSlider(props)}
            deviceType={props.deviceType}
            automationId={automationId || 'visualnav'}
            navTitle=""
            isFindstoreTheme={alignmentTheme(props)}
            vizNavFasCustomTheme={applyVizNavTheme(props, deviceType)}
            navTheme={renderTheme(
                pageType,
                _get(preferences, 'rndVisNavXs', []),
                _get(featureFlags, 'enableRndVizNav', false)
            )}
            enableJetloreVizNav={_get(featureFlags, 'enableJetloreVizNav', false)}
            revieveModal={RevieveModal}
        />
    );
};

export default (props) => {
    return componentRendered(props);
};
